//正式环境
let pro =    process.env.NODE_ENV === "production" ? "https://golfreservations.club/": "https://golfreservations.club/";

//测试环境
let dev =    process.env.NODE_ENV === "production" ? "https://apitest.golfreservations.club/": "https://apitest.golfreservations.club/";

//本地
let local = process.env.NODE_ENV === 'production' ? 'https://golfreservations.club/' : 'https://localhost:44312/';

//修改地址
let URL = pro;

export default URL;